/**
 * Cellule de tableau générique pour rendre l'identifiant/numéro d'une ligne
 * cliquable (lien hypertexte vers le système EHS source, ex: Icare), avec
 * repli en texte simple si aucun lien n'est disponible pour cette ligne.
 * Remplace la colonne "Lien" séparée sur Findings/CCV/PCED/HazID/VPC (même
 * pattern déjà utilisé sur Actions Icare et Accidentologie).
 */
import { ExternalLink } from "lucide-react";

export default function IdLinkCell({ id, href, testId }) {
  if (!href) return id;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      data-testid={testId}
      className="inline-flex items-center gap-1 font-medium text-[#0B5394] hover:underline"
    >
      {id} <ExternalLink className="h-3 w-3 shrink-0" />
    </a>
  );
}
